// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetTagsByDataItemIdRequestModel from '../../model/get-tags-by-data-item-id-request-model';
import GetTagsByDataItemIdRequestDTO from '../dto/get-tags-by-data-item-id-request-dto';
import dtoSchema from '../schemas/get-tags-by-data-item-id-request-schema';

export default abstract class GetTagsByDataItemIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetTagsByDataItemIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetTagsByDataItemIdRequestDTO>): GetTagsByDataItemIdRequestModel;
  static toModel(dto: DeepPartial<GetTagsByDataItemIdRequestDTO> | undefined | null): GetTagsByDataItemIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetTagsByDataItemIdRequestDTO> | undefined | null): GetTagsByDataItemIdRequestModel | undefined {
    return dto ? new GetTagsByDataItemIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetTagsByDataItemIdRequestModel> | GetTagsByDataItemIdRequestModel): GetTagsByDataItemIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetTagsByDataItemIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetTagsByDataItemIdRequestModel, can not map to GetTagsByDataItemIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
